import { Box, createPolymorphicComponent } from '@mantine/core';
import clsx from 'clsx';
import { useList, useUnit } from 'effector-react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { DynamicField, DynamicForm as DynamicFormModel } from 'shared/lib';
import { DynamicFormFieldProps, createDynamicFormField } from './dynamic-form-field';

export type DynamicFormProps = {
	renderProps?: (field: DynamicField) => Partial<DynamicFormFieldProps>;
} & ComponentPropsWithoutRef<'form'>;

export const createDynamicForm = (model: DynamicFormModel) => {
	const DynamicFormField = createDynamicFormField(model);

	const DynamicForm = createPolymorphicComponent<'form', DynamicFormProps>(
		forwardRef<HTMLFormElement, DynamicFormProps>(
			({ renderProps, children, className, ...props }, ref) => {
				const [submit] = useUnit([model.submit]);

				const fields = useList(model.$fieldsArray, (field) => (
					<DynamicFormField
						fieldKey={field.key}
						{...(renderProps ? renderProps(field) : {})}
					/>
				));

				return (
					<Box
						ref={ref}
						component='form'
						onSubmit={(e) => {
							e.preventDefault();
							submit();
						}}
						{...props}
						className={clsx('dynamic-form-root', className)}
					>
						{fields}
						{children}
					</Box>
				);
			},
		),
	);

	return DynamicForm;
};
